import { useFormikContext } from "formik";
import { useState } from "react";
import { Form } from "react-router-dom";
import { IPurchaseOrder } from "../../../../types/purchaseOrder.types";
import ComponentProduct from "./ComponentProduct";

export default function FormItens() {

  const [qtdComponentsPieces, setQtdComponentsPieces] = useState(1);
  const { setFieldValue } = useFormikContext<IPurchaseOrder>();

  const addComponentProduct = () => {
    setQtdComponentsPieces(qtdComponentsPieces + 1);
    setFieldValue('qtdPieces', qtdComponentsPieces + 1);
  }

  const removeComponentProduct = () => {
    setQtdComponentsPieces(qtdComponentsPieces - 1);
    setFieldValue('qtdPieces', qtdComponentsPieces - 1);
  }

  return (
    <Form>
      <div className="mt-3"></div>
      {new Array(qtdComponentsPieces).fill(null).map((_, i) => (
        <ComponentProduct
          key={i}
          index={i}
          isCounted={false}
          labelIsCounted={`isCounted${i}`}
          labelIsNotCounted={`isNotCounted${i}`}
          qtdComponentsPieces={qtdComponentsPieces}
          removeComponentProduct={removeComponentProduct}
        />
      ))}
      <div className='flex justify-center'>
        <button
          type="button"
          aria-label="Adicionar novo campo"
          className=" mt-4 pb-12 items-center h-12 rounded-md text-black"
          onClick={addComponentProduct}> + Adicionar Campo</button>
      </div>
    </Form>
  )
}
